import { Navigate, useLocation } from 'react-router-dom'
import AuthService from 'services/auth'

export default function MemberRoute ({ children }) {
  const location = useLocation ()
  const isSigned = AuthService.isSigned ()
  const isMember = AuthService.isMember ()

  if (isSigned && isMember) {
    return children
  }

  return (
    <Navigate
      to='/member/login'
      state={{ from: location }}
      replace
    />
  )
} 
